var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContinue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 107,
  height: 38.999
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8346",
  fill: "#26890d"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9304",
  d: "M106.639 31.857a1.187 1.187 0 0 0 0-1.7l-7.091-6.841a1.1 1.1 0 0 0-1.589.058 1.192 1.192 0 0 0 .056 1.646l4.994 4.821H1.127a1.168 1.168 0 0 0 0 2.335h101.882l-4.994 4.809a1.193 1.193 0 0 0-.056 1.646 1.1 1.1 0 0 0 1.589.058Zm0 0"
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(14 19)",
  fontSize: 18,
  fontFamily: "OpenSans, Open Sans"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Continue")))));
export default SvgContinue;